import { Box, Typography } from '@mui/material';

/**
 * 훈련 상세 공통 섹션 헤더
 * 파일 탐색기, 파일 탭 바, 패널 헤더 등에서 사용
 */
const TrainingDetailSectionHeader = ({ title, fontWeight = 600 }) => (
  <Box sx={{ p: 1, bgcolor: '#f5f5f5', borderBottom: '1px solid #e0e0e0' }}>
    <Typography variant="body2" fontWeight={fontWeight}>
      {title}
    </Typography>
  </Box>
);

export default TrainingDetailSectionHeader;
